import {
  CLIENT_LOGIN_SUCCES,
  CLIENT_LOGIN_ECHEC,
  CLIENT_LOGIN_RESET,
  CLIENT_LOGOUT,
  CLIENT_LISTE_SUCCES,
  CLIENT_LISTE_ECHEC,
  CLIENT_CODE_SUCCES,
  CLIENT_CODE_ECHEC,
  CLIENT_CREE_REQUETTE,
  CLIENT_CREE_SUCCES,
  CLIENT_CREE_ECHEC,
  CLIENT_CREE_RESET,
  CLIENT_CODE_REQUETTE,
  CLIENT_CODE_RESET,
  CLIENT_LOGIN_REQUETTE,
  CLIENT_SERV,
} from "../constantes/clientsConstantes";

export const clientLoginReducer = (state = { client: {} }, action) => {
  switch (action.type) {
    case CLIENT_LOGIN_REQUETTE:
      return { loading: true };
    case CLIENT_LOGIN_SUCCES:
      return { client: action.payload, loading: false };
    case CLIENT_LOGIN_ECHEC:
      return { erreur: action.payload, loading: false };
    case CLIENT_LOGIN_RESET:
      return {};
    case CLIENT_LOGOUT:
      return {};

    default:
      return state;
  }
};
export const clientListeReducer = (state = { clients: [] }, action) => {
  switch (action.type) {
    case CLIENT_LISTE_SUCCES:
      return { clients: action.payload };
    case CLIENT_LISTE_ECHEC:
      return { erreur: action.payload };
    default:
      return state;
  }
};

export const clientCodeReducer = (
  state = { client: {}, loading: false },
  action
) => {
  switch (action.type) {
    case CLIENT_CODE_REQUETTE:
      return { loading: true };
    case CLIENT_CODE_SUCCES:
      return { client: action.payload, loading: false };
    case CLIENT_CODE_ECHEC:
      return { erreur: action.payload, loading: false };
    case CLIENT_CODE_RESET:
      return { client: {}, loading: true };
    default:
      return state;
  }
};
export const clientInscReducer = (state = { client: {} }, action) => {
  switch (action.type) {
    case CLIENT_CREE_REQUETTE:
      return { loading: true };
    case CLIENT_CREE_SUCCES:
      return { loading: false, client: action.payload };
    case CLIENT_CREE_ECHEC:
      return { loading: false, erreur: action.payload };
    case CLIENT_CREE_RESET:
      return {
        loading: false,
        client: {},
      };
    default:
      return state;
  }
};
export const cliServReducer = (state = { cliServ: "" }, action) => {
  switch (action.type) {
    case CLIENT_SERV:
      return { cliServ: action.payload };
    default:
      return state;
  }
};
